import React, { useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Link, Spinner } from '@chakra-ui/react';
import { FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import * as Yup from 'yup';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import { AppError } from '../../utils/AppError';
import getValidationErrors from '../../utils/getValidationErrors';
import logoImg from '../../assets/logo/r.png';
import Input from '../../components/Inputs/Input';
import Button from '../../components/Button';

import { Container, Content, AnimationContainer, FormView } from './styles';

interface SignInFormData {
  email: string;
  password: string;
}

const SignIn: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const { signIn } = useAuth();
  const { addToast } = useToast();

	const [isLoading, setIsLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);

  // const handleSubmit = useCallback(async (data: SignInFormData) => {
	async function handleSubmit(data: SignInFormData) {
		try {
			setIsLoading(true);
			formRef.current?.setErrors({});

			const schema = Yup.object().shape({
				email: Yup.string()
					.required('E-mail obrigatório')
					.email('Digite um e-mail válido'),
				password: Yup.string().min(6, 'No minimo 6 dígitos'),
			});

			await schema.validate(data, {
				abortEarly: false,
			});

			// const usuario = await signIn({
			await signIn({
				email: data.email,
				password: data.password,
			});
		}
		catch (error) {
			if (error instanceof Yup.ValidationError) {
				const errors = getValidationErrors(error);
				formRef.current?.setErrors(errors);
				return;
			}

			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Ocorreu um erro ao fazer login, cheque as credenciais.';

			addToast({
				type: 'error',
				title: 'Erro na Autenticação',
				description: msg,
			});
		}
		finally {
			setTimeout(() => {
				setIsLoading(false);
			}, 3000);
		}
    }; // , [addToast, signIn]);

  return (
    <Container>
      <Content>
        <AnimationContainer>
          <img src={logoImg} alt="RazioDigital" />

          <FormView ref={formRef} onSubmit={handleSubmit}>
            <h1>Acesse a sua conta</h1>

            <Input
							id="email"
              name="email"
              type="email"
              placeholder="E-mail"
              icon={FiMail}
            />

            <Input
							id="password"
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Senha"
              icon={FiLock}
							iconInputRight={{
								IconRight: showPassword ? FiEyeOff : FiEye,
								showPassword,
								setShowPassword
							}}
            />

            <Button type="submit" disabled={isLoading}>
							{isLoading ? (
								<Spinner color="white" />
							) : 'ENTRAR'}
						</Button>

						<Link
							variant="underline"
							color="blue.500"
							fontSize={19}
							fontWeight={500}
							mt={8}
							href="/signup"
						>
							Ainda não tenho cadastro!
						</Link>
          </FormView>
        </AnimationContainer>
      </Content>
    </Container>
  );
};

export default SignIn;
